import { useCallback, useEffect } from 'react'
import { lineKey, useCartStore } from '../../store/cartStore'
import { useStockStore } from '../../store/stockStore'
import { listInventory } from './shopApi'
import { reconcile } from './stock'

/**
 * Reads live stock and fits the basket to it (BUG-453): lines over stock are lowered to what is left
 * and noted; sold-out lines stay for the customer to remove. Runs when `active` turns on (drawer
 * opened, checkout loaded); `refresh` runs it on demand (Continue to payment) and says whether the
 * basket changed or still holds a sold-out line. A failed read changes nothing and blocks nothing.
 */
export function useLiveStock(active: boolean) {
  const refresh = useCallback(async (): Promise<{ changed: boolean; soldOut: boolean }> => {
    let items
    try {
      items = await listInventory()
    } catch {
      return { changed: false, soldOut: false }
    }
    const live = Object.fromEntries(items.map((i) => [i.sku, i.available]))
    useStockStore.getState().setLive(live)
    const cart = useCartStore.getState()
    const { lower, soldOut } = reconcile(
      cart.items.map((i) => ({ key: lineKey(i), sku: i.sku, quantity: i.quantity })),
      live,
    )
    for (const [key, quantity] of Object.entries(lower)) cart.updateQuantity(key, quantity)
    if (Object.keys(lower).length) useStockStore.getState().noteAdjusted(lower)
    return { changed: Object.keys(lower).length > 0, soldOut: soldOut.length > 0 }
  }, [])

  useEffect(() => {
    if (active) void refresh()
  }, [active, refresh])

  return refresh
}
